import { render, staticRenderFns } from "./toaster-2-polaris-3-popcorn-page.vue?vue&type=template&id=c876cbd6&scoped=true"
import script from "./toaster-2-polaris-3-popcorn-page.vue?vue&type=script&lang=js"
export * from "./toaster-2-polaris-3-popcorn-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c876cbd6",
  null
  
)

export default component.exports